import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

import HomeHero from "@/components/home/HomeHero";
import ServicePhilosophy from "@/components/home/ServicePhilosophy";
import SignatureServices from "@/components/home/SignatureServices";
import FleetTeaser from "@/components/home/FleetTeaser";
import AirportCorporate from "@/components/home/AirportCorporate";
import WhySydneyJames from "@/components/home/WhySydneyJames";
import FinalInvitation from "@/components/home/FinalInvitation";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-ivory min-h-screen">
      <Navbar transparent />

      <HomeHero />
      <ServicePhilosophy />
      <SignatureServices />
      <FleetTeaser />
      <AirportCorporate />
      <WhySydneyJames />
      <FinalInvitation />

      <Footer />
      <FloatingActions />
    </div>
  );
}
